import React from 'react';
import { TextTag } from 'ui-toolkit';
import { eExternalOrderStatus, prettyExternalOrderStatus } from '../../../ui-toolkit/enums/eExternalOrderStatus';
import { mergeTests } from '../../../ui-toolkit/test-utilities/mergeTests';

export const ExternalOrderStatusTag: React.FC<{ externalStatus: eExternalOrderStatus | null; dataTestID?: string }> = ({
  externalStatus,
  dataTestID,
}) => (
  <TextTag
    data-test-id={mergeTests(dataTestID, 'status-tag')}
    text={prettyExternalOrderStatus[externalStatus || eExternalOrderStatus.new]}
    type={'blue'}
  />
);
